//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import { isValidUrlWithProtocol } from '@utils/urlValidation';

(function () {
  angular.module('curalate').component('universalImageActionsProductizeGrid', {
    bindings: {
      editNewProductCallback: '&',
      addProductCallback: '&',
      trackingParamsEnabled: '<',
    },
    template: require('@legacy-components/common/universal-image-actions/universal-image-actions-productize-grid.html'),
    controller: [
      '$rootScope',
      'PRODUCT_RESULTS_TYPES',
      'rx',
      'ProductSearchService',
      'SessionVarsService',
      'UniversalImageActionsApiService',
      'UniversalImageActionsTrackingService',
      function (
        $rootScope,
        PRODUCT_RESULTS_TYPES,
        rx,
        ProductSearchService,
        SessionVarsService,
        UniversalImageActionsApiService,
        UniversalImageActionsTrackingService,
      ) {
        this.searchCrawledProductPromise = null;
        this.isLoadingProductCrawl = false;

        const ngUnsubscribe = new rx.Subject();

        const setProductImage = (product) => {
          if (!product.imageUrl && product.images && product.images[0]) {
            const productImage = {
              imageUrl: product.images[0].imageUrl,
              fileId: product.images[0].fileId,
              sourceImageUrl: product.images[0].sourceImageUrl,
            };
            return productImage;
          }
          return {};
        };

        this.productSelectCallback = (product) => {
          if (!_.safeGet(product, 'destinationUrl')) {
            return;
          }
          const productImageProperties = setProductImage(product);
          const trackingSettings = {
            trackingParamsVersion: this.trackingParamsVersion,
          };
          this.addProductCallback({
            newProduct: _.extend(
              {},
              product,
              productImageProperties,
              trackingSettings,
            ),
          });
        };

        this.$onInit = () => {
          this.trackingParamsEnabled = SessionVarsService.isFeatureEnabled(
            'url_tracking_params',
          );
          this.shopifyEnabled = SessionVarsService.isFeatureEnabled(
            'ecommerce_integrations_shopify',
          );
          this.magentoEnabled = SessionVarsService.isFeatureEnabled(
            'ecommerce_integrations_magento',
          );
          this.trackingParamsVersion = null;

          let setupMessage =
            '<a href="http://developers.curalate.com/guide/product-catalogs/" target="_blank">Setup your product catalog</a>';
          if (this.shopifyEnabled) {
            setupMessage =
              '<a href="/integration-settings/ecommerce-setup" target="_blank">Setup your Shopify catalog</a>';
          } else if (this.magentoEnabled) {
            setupMessage =
              '<a href="/integration-settings/ecommerce-setup" target="_blank">Setup your Magento catalog</a>';
          }

          this.noCatalogMessage = `Bazaarvoice uses catalog data like price, category, and availability
          to turn discovery into commerce from your touchpoints. Connect your product catalog
          so we can help you monetize your media at scale, boost discoverability, and increase conversions.<br><br>
          ${setupMessage}, or tag a URL instead.`;

          this.noResultsMessage = 'Change your search term and try again.';

          this.MAX_NUM_CATALOG_SUGGESTIONS = 8;

          this.isCatalogSuggestions = () => {
            return (
              this.productResultsType ===
              PRODUCT_RESULTS_TYPES.CATALOG_SUGGESTIONS
            );
          };

          this.isCatalogResults = () => {
            return (
              this.productResultsType === PRODUCT_RESULTS_TYPES.CATALOG_RESULTS
            );
          };

          this.isNoResults = () => {
            return this.productResultsType === PRODUCT_RESULTS_TYPES.NO_RESULTS;
          };

          this.isNoCatalog = () => {
            return this.productResultsType === PRODUCT_RESULTS_TYPES.NO_CATALOG;
          };

          this.getProductList = () => {
            if (this.isCatalogSuggestions()) {
              return this.productsList.slice(
                0,
                this.MAX_NUM_CATALOG_SUGGESTIONS,
              );
            }
            return this.productsList;
          };

          this.getProductSuggestionCount = () => {
            return Math.min(
              this.MAX_NUM_CATALOG_SUGGESTIONS,
              this.productsList.length,
            );
          };

          this.createUrlTag = async () => {
            this.isLoadingProductCrawl = true;
            if (!this.searchCrawledProductPromise) {
              return;
            }

            const crawledProduct = await this.searchCrawledProductPromise;
            this.isLoadingProductCrawl = false;

            this.editNewProductCallback({ product: crawledProduct });
            ProductSearchService.clearProductsState();
            UniversalImageActionsTrackingService.clearQueryParams();
          };

          this.cancelProductTagging = () => {
            $rootScope.$broadcast('uia:products:cancelNewSpatialTag');
          };

          if (this.trackingParamsEnabled) {
            UniversalImageActionsApiService.getCurrentTrackingParams().then(
              (response) => {
                this.trackingParamsVersion = response.versionId;
              },
            );
          }

          const productsState = ProductSearchService.getProductsState();
          productsState
            .takeUntil(ngUnsubscribe)
            .subscribe((observedProductsState) => {
              this.searchCrawledProductPromise = null;
              this.resultsType = observedProductsState.resultsType;

              if (
                observedProductsState.resultsType ===
                PRODUCT_RESULTS_TYPES.CRAWL_RESULT
              ) {
                this.editNewProductCallback({
                  product: observedProductsState.productsList[0],
                });
                ProductSearchService.clearProductsState();
              } else {
                this.productsList = observedProductsState.productsList;
                this.productResultsType = observedProductsState.resultsType;

                const queryParams =
                  UniversalImageActionsTrackingService.getQueryParams();
                if (isValidUrlWithProtocol(queryParams.search)) {
                  this.searchCrawledProductPromise =
                    UniversalImageActionsApiService.crawlProducts({
                      url: queryParams.search,
                      universalItemId: queryParams.universalItemId,
                    }).then((products) => products[0]);
                }
              }
            });
        };

        this.$onDestroy = () => {
          ngUnsubscribe.next();
        };
      },
    ],
  });
})();
